import React, { useEffect } from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { FeatherClient } from '../Services/FeatherClient';
import { Tooltip } from '@mui/material';
import { tenant_id } from './common';
import '../App.css';
//import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { Link, useNavigate } from 'react-router-dom';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import userContext from '../userContext';
import Avatar from '@mui/material/Avatar';
import { useAppTheme } from '../ThemeContext';
import PaletteIcon from '@mui/icons-material/Palette';
import { Menu, MenuItem, Grid } from '@mui/material';


import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import MuiAppBar from '@mui/material/AppBar';

import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import FolderIcon from '@mui/icons-material/Folder';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { ReactComponent as RadiologyIcon } from '../assets/icon/radiology.svg'
import { ReactComponent as PrescriptionIcon } from '../assets/icon/prescriptions.svg'
import { Stack, SvgIcon, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { clientloginLogo, logoSize, letterFormat } from '../components/common';
import MedicalInformationOutlinedIcon from '@mui/icons-material/MedicalInformationOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import StarsIcon from '@mui/icons-material/Stars';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import AISuggestionModal from './AISuggestionModal';

const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': {
                ...openedMixin(theme),
                backgroundColor: theme.palette.background.paper,
                borderRight: `1px solid ${theme.palette.divider}`,
            },
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': {
                ...closedMixin(theme),
                backgroundColor: theme.palette.background.paper,
                borderRight: `1px solid ${theme.palette.divider}`,
            },
        }),
    }),
);

const Sidebar = ({ open, setOpen }) => {
    return (
        <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => { setOpen(!open) }}
            edge="start"
            sx={{
                marginRight: 3
            }}
        >
            <MenuIcon />
        </IconButton>
    )
}

const SideDrawer = ({ open, locPath }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [privileges, setPrivileges] = useState([]);
    const [Getcustomformdata, setGetcustomformdata] = useState([]);

    useEffect(() => {
        fetchApplicationandFunctions();
        FetchCustomForm();
    }, []);

    const fetchApplicationandFunctions = async () => {
        try {
            const data = { application_id: 'PATIENTPORTAL' };
            const feathersClient = await FeatherClient();
            const priviledgeService = feathersClient.service('privilege');

            const response = await priviledgeService.create(data, {
                headers: {
                    'x-tenant-id': tenant_id,
                    'X-Service-Method': 'getApplicationsPrivilege'
                },
            });

            const functionIds = response?.data[0];
            setPrivileges(functionIds);

        } catch (error) {
            console.error('❌ fetchApplicationandFunctions error:', error);
        } finally {

        }
    };

    const FetchCustomForm = async () => {
        const userdetailsID = localStorage.getItem('mobileapp_userdetailsID');
        const tempMrnNo = localStorage.getItem('temp_mrn_no');

        try {
            const feathersClient = await FeatherClient();
            const CustomForm = feathersClient.service('patient-custom-form');

            const customFormParams = {
                'user_details_id': Number(userdetailsID),
                'temporary_mrn_no': Number(tempMrnNo),
                'form_status': 'PD'
            };

            const response = await CustomForm.create(customFormParams, {
                headers: {
                    'X-Service-Method': 'getPatientCustomFormDetails',
                    'x-tenant-id': tenant_id
                },
            });

            setGetcustomformdata(response.data);
        } catch (error) {
            console.warn('Error fetching form:', error);
            setGetcustomformdata([]);
        } finally {

        }
    };

    return (
        <Drawer variant="permanent" open={open}>
            <DrawerHeader />
            <Divider />
            <List
                sx={{
                    "&": {
                        pt: 0
                    },
                    "& > .MuiListItem-root": {
                        display: 'block'
                    },
                    "& > .MuiListItem-root > .MuiButtonBase-root": {
                        minHeight: 52,
                        justifyContent: open ? 'initial' : 'center',
                        px: 2.5,
                        mx: 1,
                        borderRadius: '12px',
                        mb: 0.8,
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        border: '1px solid transparent',
                    },
                    "& > .MuiListItem-root > .MuiButtonBase-root:hover": {
                        backgroundColor: theme.palette.primary.light,
                        color: theme.palette.primary.main,
                        borderColor: `${theme.palette.primary.main}25`,
                        "& .MuiListItemIcon-root": {
                            color: theme.palette.primary.main,
                        }
                    },
                    "& > .MuiListItem-root > .MuiButtonBase-root > .MuiListItemIcon-root": {
                        minWidth: 0,
                        mr: open ? 2.5 : 'auto',
                        justifyContent: 'center',
                        transition: 'color 0.2s',
                        color: theme.palette.text.secondary,
                    },
                    "& > .MuiListItem-root > .MuiButtonBase-root > .MuiListItemText-root": {
                        opacity: open ? 1 : 0,
                        color: theme.palette.text.primary,
                        "& .MuiTypography-root": {
                            fontWeight: 500,
                        }
                    },
                    "& > .MuiListItem-root > .MuiButtonBase-root.Mui-selected": {
                        backgroundColor: theme.palette.primary.main,
                        backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                        boxShadow: `0 8px 16px -4px ${theme.palette.primary.main}50`,
                        borderColor: 'transparent',
                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                            filter: 'brightness(1.1)',
                        }
                    },
                    "& > .MuiListItem-root > .MuiButtonBase-root.Mui-selected > .MuiListItemIcon-root": {
                        color: '#fff'
                    },
                    "& > .MuiListItem-root > .MuiButtonBase-root.Mui-selected > .MuiListItemText-root": {
                        color: '#fff',
                        "& .MuiTypography-root": {
                            fontWeight: 700,
                        }
                    }
                }}
            >

                {privileges?.PPBOOKAPPOINTMENT && (
                    <ListItem disablePadding>
                        <Tooltip title="Find doctor" placement="right" arrow>
                            <ListItemButton
                                component={Link}
                                to={'appointment'}
                                selected={locPath.pathname === "/appointment"}
                            >
                                <ListItemIcon>
                                    <PersonSearchIcon />
                                </ListItemIcon>
                                <ListItemText primary="Find Doctor" />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )}

                {/* {privileges?.PPBOOKAPPOINTMENT && (
                    <ListItem disablePadding>
                        <Tooltip title="AI Health Assistant" placement="right" arrow>
                            <ListItemButton
                                onClick={() => navigate('/ai-assistant')}
                                selected={locPath.pathname === "/ai-assistant"}
                            >
                                <ListItemIcon>
                                    <StarsIcon />
                                </ListItemIcon>
                                <ListItemText primary="AI Assistant" />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )} */}

                {privileges?.PPVIEWAPPOINTMENT && (
                    <ListItem disablePadding>
                        <Tooltip title="Appointments" placement="right" arrow>
                            <ListItemButton
                                component={Link}
                                to={'app-details'}
                                selected={locPath.pathname === "/app-details"}
                            >
                                <ListItemIcon>
                                    <EventNoteIcon />
                                </ListItemIcon>
                                <ListItemText primary="Appointments" />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )}
                {privileges?.PPLABORATORY && (
                    <ListItem disablePadding>
                        <Tooltip title="Laboratory" placement="right" arrow>
                            <ListItemButton
                                component={Link}
                                to={'laboratory'}
                                selected={locPath.pathname === "/laboratory"}
                            >
                                <ListItemIcon>
                                    <ScienceOutlinedIcon />
                                </ListItemIcon>
                                <ListItemText primary="Laboratory" />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )}
                {/* {privileges?.PPLABORATORY && (
                    <ListItem disablePadding>
                        <Tooltip title="Smart Trend Report" placement="right" arrow>
                            <ListItemButton
                                onClick={() => navigate('/lab-trend')}
                                selected={locPath.pathname === "/lab-trend"}
                                sx={{
                                    "&.Mui-selected": {
                                        background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%) !important',
                                    }
                                }}
                            >
                                <ListItemIcon>
                                    <TrendingUpIcon sx={{ color: locPath.pathname === "/lab-trend" ? '#fff' : '#4f46e5' }} />
                                </ListItemIcon>
                                <ListItemText primary="Smart Trend" />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )} */}

                {privileges?.PPRADIOLOGY && (
                    <ListItem disablePadding>
                        <Tooltip title="Radiology" placement="right" arrow>
                            <ListItemButton
                                component={Link}
                                to={'radiology'}
                                selected={locPath.pathname === "/radiology"}
                            >
                                <ListItemIcon>
                                    <SvgIcon component={RadiologyIcon} inheritViewBox />
                                </ListItemIcon>
                                <ListItemText primary="Radiology" />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )}
                {privileges?.PPMEDICATION && (
                    <ListItem disablePadding>
                        <Tooltip title="My Medication" placement="right" arrow>
                            <ListItemButton
                                component={Link}
                                to="my-medication"
                                selected={locPath.pathname === "/my-medication"}
                            >
                                <ListItemIcon>
                                    <SvgIcon component={MedicalInformationOutlinedIcon} inheritViewBox />
                                </ListItemIcon>
                                <ListItemText primary="My Medication" />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )}

                {/* ✅ Show if privilege MATREATMENT is available */}
                {privileges?.PPTREATMENT && (
                    <ListItem disablePadding>
                        <Tooltip title="Treatment" placement="right" arrow>
                            <ListItemButton
                                component={Link}
                                to="treatment"
                                selected={locPath.pathname === "/treatment"}
                            >
                                <ListItemIcon>
                                    <SvgIcon component={PrescriptionIcon} inheritViewBox />
                                </ListItemIcon>
                                <ListItemText primary="Treatment" />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )}

                {privileges?.PPDOCUMENT && (
                    <ListItem disablePadding>
                        <Tooltip title="Document" placement="right" arrow>
                            <ListItemButton
                                component={Link}
                                to={'patient-folder'}
                                selected={locPath.pathname === "/patient-folder"}
                            >
                                <ListItemIcon>
                                    <FolderIcon />
                                </ListItemIcon>
                                <ListItemText primary="Document" />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )}
                {privileges?.PPCONTACT && (
                    <ListItem disablePadding>
                        <Tooltip title="Contact Us" placement="right" arrow>
                            <ListItemButton
                                component={Link}
                                to={'contact-us'}
                                selected={locPath.pathname === "/contact-us"}
                            >
                                <ListItemIcon>
                                    <ContactsOutlinedIcon />
                                </ListItemIcon>
                                <ListItemText primary="Contact Us" />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )}
                {privileges?.PPFAMILYMEMBER && (
                    <ListItem disablePadding>
                        <Tooltip title="Family Member" placement="right" arrow>
                            <ListItemButton
                                component={Link}
                                to={'family-member'}
                                selected={locPath.pathname === "/family-member"}
                            >
                                <ListItemIcon>
                                    <PeopleAltOutlinedIcon />
                                </ListItemIcon>
                                <ListItemText primary="Family Member" />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )}
                {privileges?.PPSUBMITREQUEST && (
                    <ListItem disablePadding>
                        <Tooltip title="SubmitRequest" placement="right" arrow>
                            <ListItemButton
                                component={Link}
                                to={'submit-request'}
                                selected={locPath.pathname === "/submit-request"}
                            >
                                <ListItemIcon>
                                    <SvgIcon component={PrescriptionIcon} inheritViewBox />
                                </ListItemIcon>
                                <ListItemText primary="Submit Request" />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )}

                {privileges?.PPINTAKEFORM && (
                    <ListItem disablePadding>
                        <Tooltip title="IntakeForm" placement="right" arrow>
                            <ListItemButton
                                component={Link}
                                to={'intake-form'}
                                selected={locPath.pathname === "/intake-form"}
                            >
                                <ListItemIcon style={{ position: "relative" }}>
                                    <SvgIcon component={InsertDriveFileIcon} inheritViewBox />
                                    {Getcustomformdata?.length > 0 && <span className="blinking-dot" />}
                                </ListItemIcon>

                                <ListItemText primary="IntakeForm" />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )}

            </List>
        </Drawer>
    );
}

const AvatarUser = ({ userSidebarOpen, setUserSidebarOpen, firstLetters, fullname, displayMrn, handleLogout }) => {
    const theme = useTheme();
    return (
        <Box sx={{ ml: 'auto' }}>

            <Avatar
                className='custom-avatar'
                sx={{ cursor: 'pointer' }}
                onClick={() => setUserSidebarOpen(true)}
            >
                {firstLetters}
            </Avatar>
            <MuiDrawer
                sx={{ zIndex: 1201 }}
                anchor='right'
                open={userSidebarOpen}
                onClose={() => setUserSidebarOpen(false)}
            >
                <Box sx={{ width: 350 }}>
                    <Stack direction="row" spacing={2} sx={{ py: 3, px: 3, backgroundColor: theme.palette.primary.light, borderBottom: `1px solid ${theme.palette.divider}` }}>
                        <Avatar
                            sx={{ width: 64, height: 64, boxShadow: '0 0 0 4px #fff, 0 4px 6px -1px rgba(0,0,0,0.1)' }}
                            className='custom-avatar'
                        >
                            {firstLetters}
                        </Avatar>
                        <Stack spacing={0.5} justifyContent="center">
                            <Typography variant="h6" sx={{ fontSize: '1.1rem', color: theme.palette.primary.dark }}>
                                {fullname}
                            </Typography>
                            <Typography className="text-grey" variant="body2">{displayMrn}</Typography>
                        </Stack>
                    </Stack>

                    <List sx={{
                        px: 1.5,
                        py: 1,
                        "& > .MuiListItem-root > .MuiButtonBase-root": {
                            borderRadius: '8px',
                            mb: 1,
                        },
                        "& > .MuiListItem-root > .MuiButtonBase-root > .MuiListItemIcon-root": {
                            minWidth: 0,
                            mr: 2
                        }
                    }}>
                        <ListItem disablePadding>
                            <ListItemButton onClick={handleLogout}>
                                <ListItemIcon>
                                    <LogoutOutlinedIcon color='secondary' />
                                </ListItemIcon>
                                <ListItemText primary="Logout" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </MuiDrawer>

        </Box>
    )
}


const Header = (props) => {

    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const [user, setUser] = useContext(userContext);
    const [userSidebarOpen, setUserSidebarOpen] = useState(false);
    const [displayMrn, setDisplayMrn] = useState('');
    const [fullname, setfullname] = useState('');
    const [firstLetters, setFirstLetters] = useState('');
    const { primaryColor, setPrimaryColor } = useAppTheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const openThemeMenu = Boolean(anchorEl);

    const firstname = localStorage.getItem('first_name');
    const lastname = localStorage.getItem('last_name');
    const middlename = localStorage.getItem('middle_name');
    const mrnNo = localStorage.getItem('mrn_no');
    const tempMrnNo = localStorage.getItem('temp_mrn_no');

    useEffect(() => {
        const validFirstName = firstname && firstname.trim() ? firstname : '';
        const validMiddleName = middlename && middlename.trim() ? middlename : '';
        const validLastName = lastname && lastname.trim() ? lastname : '';

        const subname = capitalizeEachWord(
            validMiddleName !== 'undefined' && validMiddleName !== null && validMiddleName !== 'null'
                ? `${validFirstName} ${validMiddleName} ${validLastName}`
                : `${validFirstName} ${validLastName}`.trim()
        );


        const firstLetters =
            validMiddleName !== 'undefined' && validMiddleName !== null && validMiddleName !== 'null'
                ? [validFirstName[0], validMiddleName[0], validLastName[0]].filter(Boolean).map(letter => letter.toUpperCase()).join('')
                : [validFirstName[0], validLastName[0]].filter(Boolean).map(letter => letter.toUpperCase()).join('');

        setFirstLetters(firstLetters);
        setfullname(subname);
        if (mrnNo !== null && mrnNo !== '' && mrnNo !== 'null' && mrnNo !== 'undefined') {
            setDisplayMrn('MRN No: ' + mrnNo);
        } else if (tempMrnNo !== 'null' && tempMrnNo !== '' && tempMrnNo !== null && tempMrnNo !== 'undefined') {
            setDisplayMrn('T-MRN No: ' + tempMrnNo);
        }
    }, [firstname, lastname, middlename, mrnNo, tempMrnNo]);

    const handleThemeClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleThemeClose = () => {
        setAnchorEl(null);
    };

    const handleColorSelect = (color) => {
        setPrimaryColor(color);
        handleThemeClose();
    };

    const themeColors = [
        { name: 'Midnight Navy', color: '#1a1f2e' },
        { name: 'Indigo Pro', color: '#3f51b5' },
        { name: 'Royal Purple', color: '#6633cc' },
        { name: 'Violet', color: '#7c3aed' },
        { name: 'Ocean Blue', color: '#0277bd' },
        { name: 'Teal', color: '#00695c' },
        { name: 'Forest Green', color: '#2e7d32' },
        { name: 'Emerald', color: '#059669' },
        { name: 'Slate', color: '#475569' },
        { name: 'Charcoal', color: '#374151' },
        { name: 'Crimson', color: '#c62828' },
        { name: 'Rose', color: '#be185d' },
        { name: 'Amber', color: '#b45309' },
        { name: 'Deep Orange', color: '#e64a19' },
        { name: 'Steel Blue', color: '#1565c0' },
        { name: 'Graphite', color: '#4a5568' },
    ];


    const capitalizeEachWord = str => {
        if (typeof str !== 'string') {
            return '';
        }

        // Capitalize the first letter of each word
        return str
            .toLowerCase()
            .split(' ')
            .map((word, index) => {
                // Capitalize first letter of each word except for "Dr."
                if (index === 0 && word.startsWith('dr.')) {
                    return 'Dr.' + word.slice(3).charAt(0).toUpperCase() + word.slice(4);
                } else {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                }
            })
            .join(' ');
    };

    const handleLogout = () => {
        navigate('/login');
        setUser("appBook");
    };


    let loginUserDisplay;
    let sidebarIcon;
    let sideDrawerMenu;

    if (user === "loginUserDet") {
        loginUserDisplay = (
            <AvatarUser
                userSidebarOpen={userSidebarOpen}
                setUserSidebarOpen={setUserSidebarOpen}
                firstLetters={firstLetters}
                fullname={fullname}
                displayMrn={displayMrn}
                handleLogout={handleLogout}
            />
        );
        sidebarIcon = <Sidebar open={open} setOpen={setOpen} />;
        sideDrawerMenu = <SideDrawer open={open} locPath={props.locPath} />;
    } else {
        loginUserDisplay = <Button variant="outlined" size="small" onClick={() => navigate('/login')} sx={{ ml: 'auto' }}>Logout</Button>
    }

    return (
        <div style={{ display: 'contents' }}>
            <AppBar position="fixed" color="inherit" elevation={0} className="my-appbar">
                <Toolbar>
                    {sidebarIcon}
                    <Box component="img" src={clientloginLogo} sx={{ width: `${logoSize}px`, height: 'auto' }} />

                    <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Tooltip title="Change theme" arrow>
                            <IconButton
                                onClick={handleThemeClick}
                                sx={{
                                    color: primaryColor,
                                    bgcolor: `${primaryColor}15`,
                                    '&:hover': { bgcolor: `${primaryColor}25` }
                                }}
                            >
                                <PaletteIcon />
                            </IconButton>
                        </Tooltip>

                        <Menu
                            anchorEl={anchorEl}
                            open={openThemeMenu}
                            onClose={handleThemeClose}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            PaperProps={{
                                sx: {
                                    mt: 1,
                                    borderRadius: 3,
                                    p: 2,
                                    minWidth: 260,
                                    boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                                    border: '1px solid',
                                    borderColor: 'divider',
                                }
                            }}
                        >
                            <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ letterSpacing: 1, textTransform: 'uppercase', mb: 1.5, display: 'block', px: 0.5 }}>
                                Theme Color
                            </Typography>
                            <Divider sx={{ mb: 1.5 }} />

                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(4, 1fr)',
                                    gap: 1,
                                }}
                            >
                                {themeColors.map((preset) => (
                                    <Tooltip key={preset.color} title={preset.name} placement="top" arrow>
                                        <Box
                                            onClick={() => handleColorSelect(preset.color)}
                                            sx={{
                                                position: 'relative',
                                                width: 44,
                                                height: 44,
                                                borderRadius: 2,
                                                bgcolor: preset.color,
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '2px solid',
                                                borderColor: primaryColor === preset.color ? 'white' : 'transparent',
                                                outline: primaryColor === preset.color ? `3px solid ${preset.color}` : '2px solid transparent',
                                                transition: 'all 0.15s ease',
                                                '&:hover': {
                                                    transform: 'scale(1.12)',
                                                    boxShadow: `0 4px 12px ${preset.color}55`,
                                                },
                                            }}
                                        >
                                            {primaryColor === preset.color && (
                                                <Typography sx={{ color: 'white', fontWeight: 'bold' }}>✓</Typography>
                                            )}
                                        </Box>
                                    </Tooltip>
                                ))}
                            </Box>
                        </Menu>


                        {loginUserDisplay}
                    </Box>
                </Toolbar>
            </AppBar>

            {sideDrawerMenu}

        </div>
    )
}

export default Header;
